// Full-document render of the toppers LegalPage: PageSkeleton (the React
// document shell) wrapping the ``legal_page.html`` layout DOM around the
// existing ``LegalPageBodyTemplate`` body assembly. The template
// rendered the body in {% block layout %} inside
// ``#legal-page.l-capped-width.legal-page > .content`` -- ``.legal-page`` is a
// live CSS anchor (``_legal-page.scss``), so the wrapper DOM is byte-faithful.
import React from "react";

import { templates } from "@reactivated";

import { LegalPageBody } from "../components/LegalPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader / SiteFooter chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to
// which these are assignable.
type IProps = templates.LegalPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    const { page } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div id="legal-page" className="l-capped-width legal-page">
                <div className="content">
                    {page.show_title && <h1>{page.title}</h1>}
                    {/* {% if page.body %} = StreamValue truthiness
                        (an empty stream is falsy). */}
                    {page.body.value.length > 0 ? (
                        <LegalPageBody page={page} />
                    ) : null}
                </div>
            </div>
        </PageSkeleton>
    );
};
